import { FC, useMemo } from 'react';
import { QuoteExperienceSchemaPanelWrapper, QuoteExperienceSchemaPanelWrapperProps } from './QuoteExperienceSchemaPanelWrapper';
import { processSchema } from '../../../../api/quote-experience/SchemaProcessorRegistry';
import { BaseImagePath } from '../ImageManager/ImageManager.panel';
import { useBundleImagePreviews } from './useBundleImagePreviews';

export interface ImageEnrichedSchemaPanelWrapperProps extends Omit<QuoteExperienceSchemaPanelWrapperProps, 'imagePreviewMap'> {
    baseImagePath?: BaseImagePath;
    bundleGuid: string | undefined;
}

export const ImageEnrichedSchemaPanelWrapper: FC<ImageEnrichedSchemaPanelWrapperProps> = ({
    bundleGuid,
    baseImagePath = 'images',
    schema,
    schemaType,
    current,
    ...rest
}) => {
    const { availableImages, imagePreviewMap } = useBundleImagePreviews(bundleGuid, baseImagePath, current[baseImagePath]);

    const enrichedSchema = useMemo(
        () => processSchema(schemaType, schema, { availableImages }),
        [schema, schemaType, availableImages]
    );

    return (
        <QuoteExperienceSchemaPanelWrapper
            {...rest}
            current={current}
            schema={enrichedSchema}
            schemaType={schemaType}
            imagePreviewMap={imagePreviewMap}
        />
    );
};
